import _Message from "@arco-design/web-react/es/Message";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState, useEffect } from 'react';
import { IconLoading } from '@arco-design/web-react/icon';
import { useSelector } from 'react-redux';
import { getCompileCSS } from '@src/utils/api/common';
import { postPreviewMessage, POST_MESSAGE_ACTIONS } from '@src/utils/postMessage';
import { getItem, themeModeKey } from '@src/utils/storage';
import useStorage from '@src/hooks/useStorage';
import DomInspector from '../../../setting/components/dom-inspector';
import usePreviewVersion from '@src/hooks/usePrviewVersion';
import { themeDepLibrary } from '@src/utils/constants';
var themeMode = getItem(themeModeKey);
export default function PreviewContent(props) {
  var _this = this;
  var themeInfo = props.themeInfo,
    visible = props.visible;
  var _a = __read(useState(true), 2),
    loading = _a[0],
    setLoading = _a[1];
  var editTokens = useSelector(function (state) {
    return __assign(__assign({}, state.token.savedTokens), state.token.editTokens);
  });
  var _b = useSelector(function (state) {
      return {
        reduxThemeMode: state.theme.themeMode,
        themeConfig: state.theme.themeConfig
      };
    }),
    reduxThemeMode = _b.reduxThemeMode,
    themeConfig = _b.themeConfig;
  var _c = __read(useStorage('dom-inspector', 'false'), 2),
    inspectorEnable = _c[0],
    setInspectorEnable = _c[1];
  var previewVersion = usePreviewVersion().currentPreviewVersion;
  var lessVars = Object.values(editTokens).sort(function (a, b) {
    return a.key > b.key ? -1 : 1;
  }).reduce(function (total, next) {
    total[next.key] = next.value;
    return total;
  }, {});
  var compiling = function compiling() {
    return __awaiter(_this, void 0, void 0, function () {
      var result, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!visible) {
              return [2];
            }
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            postPreviewMessage(POST_MESSAGE_ACTIONS.COMPILING, true);
            return [4, getCompileCSS({
              themeId: themeConfig.themeId,
              tokens: Object.values(editTokens),
              onlyDefault: true,
              customizeCss: true
            })];
          case 2:
            result = _a.sent();
            postPreviewMessage(POST_MESSAGE_ACTIONS.COMPILE_PREVIEW, {
              styleContent: result,
              tokens: lessVars,
              themeId: themeConfig.themeId
            });
            return [3, 4];
          case 3:
            e_1 = _a.sent();
            console.error('编译失败！', e_1);
            _Message.error('编译失败！');
            return [3, 4];
          case 4:
            postPreviewMessage('compiling', false);
            return [2];
        }
      });
    });
  };
  useEffect(function () {
    var handleSwitchInspector = function handleSwitchInspector(e) {
      var _a = e.data,
        type = _a.type,
        value = _a.value;
      if (type === 'domInspector') {
        setInspectorEnable(value);
      }
    };
    window.addEventListener('message', handleSwitchInspector);
    return function () {
      window.removeEventListener('message', handleSwitchInspector);
    };
  }, [location.pathname]);
  React.useEffect(function () {
    visible && compiling();
  }, [visible]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("iframe", {
    style: {
      opacity: loading ? 0 : 1
    },
    onLoad: function onLoad() {
      setLoading(false);
      if (themeMode !== reduxThemeMode) {
        postPreviewMessage(POST_MESSAGE_ACTIONS.SET_DARK_THEME, reduxThemeMode === 'dark');
      }
      compiling();
    },
    name: "previewDemoFrame",
    src: (themeInfo.depLibrary === themeDepLibrary.vue ? '/themes/demo-vue/preview' : '/themes/demo/preview') + "?themeId=" + themeInfo.themeId + "&themeMode=" + themeMode + "&previewVersion=" + previewVersion,
    title: "demo"
  }), loading && /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      fontSize: 20,
      color: 'rgb(var(--primary-6))',
      position: 'absolute',
      top: '40%',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(IconLoading, null)), /*#__PURE__*/React.createElement(DomInspector, {
    enable: JSON.parse(inspectorEnable),
    iframeLoaded: !loading,
    frame: window.previewDemoFrame
  }));
}